import { showSuccess } from '@calendly/alert'
import { I18n } from '@calendly/i18n'

import { rootApi } from 'root-api'

const api = rootApi.enhanceEndpoints({ addTagTypes: ['CONTACT_USER_SETTINGS'] }).injectEndpoints({
  endpoints: (build) => ({
    fetchContactUserSettings: build.query({
      query: () => ({ url: '/api/account/contacts_settings' }),
      providesTags: ['CONTACT_USER_SETTINGS']
    }),
    updateContactUserSettings: build.mutation({
      query: ({ settings }) => ({ url: '/api/account/contacts_settings', method: 'PUT', data: settings }),
      invalidatesTags: ['CONTACT_USER_SETTINGS'],
      extraOptions: {
        onSuccess: (_, { dispatch }) => dispatch(showSuccess(I18n.t('publisher.flash.settings_saved')))
      }
    })
  })
})

export const {
  useFetchContactUserSettingsQuery,
  useUpdateContactUserSettingsMutation,
} = api
